<div>
  <!-- Add Rule Button -->
  <div class="d-block text-end">
    <button
      class="btn btn-primary-dark btn-sm rounded-small ms-3 text-xxs shadow text-dark mb-3"
      @click="refresh_countdown_data"
      :disabled="loading"
      title="Refresh countdown timers"
    >
     Refresh Countdown
    </button>
    <button
      class="btn btn-primary-dark btn-sm rounded-small ms-3 text-xxs shadow text-dark mb-3"
      @click="open_create_rule_modal"
    >
      Add Rule
    </button>
  </div>

  <!-- Rules Table -->
  <div class="">
    <div class="glassy-table shadow-sm  rounded-lg p-3 table-responsive text-xs">
      <table
        v-if="table_safe_rule_list.length > 0"
        id="rule_management_table"
        class="table table-hover"
      >
        <thead class="custom-header">
          <tr>
            <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">No</th>
            <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Name</th>
            <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Description</th>
            <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Entity Type</th>
            <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Logical Operator</th>
            <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Days Remaining</th>
            <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Version</th>
            <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(rule, index) in table_safe_rule_list" :key="rule.id">
            <td class="text-start">{{ index + 1 }}</td>
            <td class="text-start">{{ rule.name }}</td>
            <td class="text-start">{{ rule.description }}</td>
            <td>{{ rule.entity_type_name }}</td>
            <td> {{ rule.logical_operator || 'AND' }}</td>
            <td>
              <span 
                :class="get_countdown_badge_class(rule.days_remaining, rule.countdown_status)"
                :title="rule.next_eval_date ? 'Next evaluation: ' + new Date(rule.next_eval_date).toLocaleDateString() : ''"
              >
                {{ format_countdown_display(rule.days_remaining, rule.countdown_status) }}
              </span>
            </td>
            <td class="text-start">{{ rule.version }}</td>
            <td class="text-nowrap">
            <div class="d-flex gap-1">
              <button
                class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
                @click="open_edit_rule_modal(rule)"
              >
                Edit
              </button>

              <button
                class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
                @click="open_assign_questions_modal(rule)"
              >
                Assign
              </button>

              <button
                class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
                @click="open_conditions_page(rule)" 
              >
                Conditions
              </button>

              <button
                class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
                @click="confirm_delete_rule(rule)"
              >
                Delete
              </button>

            </div>
          </td>

          </tr>
        </tbody>
      </table>

      <!-- Empty State -->
      <div v-else class="text-center py-5">
        <h6 class="text-muted text-xs mb-2">No Rules Found</h6>
        <p class="text-xxs text-muted">
          Click <strong>Add Rule</strong> to create your first compliance rule.
        </p>
      </div>
    </div>
  </div>

  <!-- Create/Edit Rule Modal -->
  <teleport to="body">
    <div
      class="modal fade"
      id="create_rule_modal"
      ref="createRuleModal"
      tabindex="-1"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content bg-white rounded-3 p-0 shadow-lg border-0">
          <!-- Modal Header -->
          <div class="modal-header border-bottom-0 cute-header shadow-sm">
            <p class="modal-title text-white text-xxs" id="create_rule_label">
              {{ is_editing ? 'Edit Compliance Rule' : 'Create Compliance Rule' }}
            </p>
            <button
              type="button"
              class="modal-btn-close btn-close btn-close-white"
              @click="close_rule_modal"
              aria-label="Close"
            ></button>
          </div>

          <!-- Modal Body -->
          <div class="modal-body p-3">
            <!-- Rule Name -->
            <div class="modal-form-group form-group mb-3">
              <label for="rule_name" class="modal-form-label form-label text-xxs">Rule Name:</label>
              <input
                type="text"
                id="rule_name"
                v-model="rule_form.name"
                class="modal-form-control form-control text-xs rounded-small p-2 shadow-sm"
                placeholder="Please enter a rule name"
              >
            </div>

            <!-- Rule Description -->
            <div class="modal-form-group form-group mb-3">
              <label for="rule_description" class="modal-form-label form-label text-xxs">Description (Optional):</label>
              <textarea
                id="rule_description"
                v-model="rule_form.description"
                class="modal-form-control form-control text-xs rounded-small p-2 shadow-sm"
                placeholder="Please enter a description"
                rows="3"
              ></textarea>
            </div>

            <!-- Time Settings -->
                <div class="modal-form-group form-group mb-3">
                <div class="row">
                    <!-- Initial Grace Period (days) -->
                    <div class="col-md-4">
                    <label for="initial_grace_period" class="modal-form-label form-label text-xxs">Initial Grace Period:</label>
                    <div class="input-group">
                        <input
                        type="number"
                        id="initial_grace_period"
                        v-model="rule_form.initial_grace_period_days"
                        class="modal-form-control form-control text-xs rounded-small p-2 shadow-sm"
                        placeholder="Enter days"
                        min="0"
                        step="1"
                        >
                        <span class="input-group-text text-xs">days</span>
                    </div>
                    <small class="text-muted text-xxs">Days allowed for first compliance check</small>
                    <div v-if="rule_form.initial_grace_period_days > 0" class="mt-1">
                      <small class="text-success text-xxs">
                        <i class="fas fa-clock"></i> Countdown will start: {{ rule_form.initial_grace_period_days }} days
                      </small>
                    </div>
                    </div>

                    <!-- Frequency (dropdown with custom option) -->
                    <div class="col-md-4">
                    <label for="frequency" class="modal-form-label form-label text-xxs">Frequency:</label>
                    <select
                        id="frequency"
                        v-model="rule_form.frequency_type"
                        class="modal-form-control form-select text-xs rounded-small p-2 shadow-sm"
                        @change="onFrequencyTypeChange"
                    >
                        <option value="" disabled>Select frequency</option>
                        <option value="weekly">Weekly</option>
                        <option value="biweekly">Bi-weekly</option>
                        <option value="monthly">Monthly</option>
                        <option value="quarterly">Quarterly</option>
                        <option value="biannually">Bi-annually</option>
                        <option value="annually">Annually</option>
                        <option value="custom">Custom</option>
                    </select>
                    
                    <!-- Custom frequency input (shown when custom is selected) -->
                    <div v-if="rule_form.frequency_type === 'custom'" class="mt-2">
                        <div class="input-group">
                        
                        </div>
                    </div>
                    <small class="text-muted text-xxs">How often to check compliance</small>
                    </div>

                    <!-- Recurring Grace Period (days) -->
                    <div class="col-md-4">
                    <label for="recurring_grace_period" class="modal-form-label form-label text-xxs">Recurring Grace Period:</label>
                    <div class="input-group">
                        <input
                        type="number"
                        id="recurring_grace_period"
                        v-model="rule_form.recurring_grace_period_days"
                        class="modal-form-control form-control text-xs rounded-small p-2 shadow-sm"
                        placeholder="Enter days"
                        min="0"
                        step="1"
                        >
                        <span class="input-group-text text-xs">days</span>
                    </div>
                    <small class="text-muted text-xxs">Days allowed for each recurring check</small>
                    </div>

                <!-- Logical Operator -->
                  <div class="modal-form-group form-group mb-3">
                    <label for="logical_operator" class="modal-form-label form-label text-xxs">
                      Logical Operator:
                    </label>
                    <select
                      id="logical_operator"
                      v-model="rule_form.logical_operator"
                      class="modal-form-control form-select text-xs rounded-small p-2 shadow-sm"
                    >
                      <option value="AND">AND — All conditions must pass</option>
                      <option value="OR">OR — At least one condition must pass</option>
                      <option value="NOT">NOT — Condition must be false</option>
                      <option value="XOR">XOR — Exactly one condition must pass</option>
                      <option value="NAND">NAND — Not all conditions can be true</option>
                    </select>
                    <small class="text-muted text-xxs">
                      Controls how multiple conditions are combined to determine compliance
                    </small>
                  </div>
                </div>
                
                <!-- Help text -->
                <div class="row mt-2">
                    <div class="col-12">
                    <p class="text-xxs text-muted mb-0">
                        <small>
                        • <strong>Initial Grace Period:</strong> Days allowed for first compliance check after rule creation<br>
                        • <strong>Frequency:</strong> How often the compliance check repeats<br>
                        • <strong>Recurring Grace Period:</strong> Days allowed after each scheduled check date
                        </small>
                    </p>
                    </div>
                </div>
                </div>

            <!-- Version -->
            <div class="modal-form-group form-group mb-3">
              <label for="version" class="modal-form-label form-label text-xxs">Version:</label>
              <input
                type="number"
                id="version"
                v-model="rule_form.version"
                class="modal-form-control form-control text-xs rounded-small p-2 shadow-sm"
              >
            </div>
          </div>

          <!-- Modal Footer -->
          <div class="modal-footer border-top p-3">
            <button
              type="button"
              class="btn btn-secondary btn-sm rounded-small text-xxs shadow text-dark me-2"
              @click="close_rule_modal"
            >
              Cancel
            </button>
            <button
              v-if="is_editing"
              type="button"
              class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
              @click="update_rule"
              :disabled="is_creating_rule"
            >
              {{ is_creating_rule ? 'Updating...' : 'Update Rule' }}
            </button>
            <button
              v-else
              type="button"
              class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
              @click="create_rule"
              :disabled="is_creating_rule"
            >
              {{ is_creating_rule ? 'Creating...' : 'Save Rule' }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </teleport>

  <!-- Delete Confirmation Modal -->
  <teleport to="body">
    <div
      class="modal fade"
      id="delete_confirmation_modal"
      ref="deleteConfirmationModal"
      tabindex="-1"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content bg-white rounded-3 p-0 shadow-lg border-0">
          <!-- Modal Header -->
          <div class="modal-header border-bottom-0 cute-header shadow-sm">
            <p class="modal-title text-white text-xxs">Confirm Delete</p>
            <button
              type="button"
              class="modal-btn-close btn-close btn-close-white"
              @click="close_delete_modal"
              aria-label="Close"
            ></button>
          </div>

          <!-- Modal Body -->
          <div class="modal-body p-3">
            <div class="text-center mb-3">
              <i class="fas fa-exclamation-triangle text-warning fa-2x mb-2"></i>
            </div>
            <p class="text-xs text-center mb-2">
              Are you sure you want to delete the rule "<strong>{{ rule_to_delete?.name }}</strong>"?
            </p>
            <p class="text-xxs text-muted text-center">This action cannot be undone.</p>
          </div>

          <!-- Modal Footer -->
          <div class="modal-footer border-top p-3">
            <button
              type="button"
              class="btn btn-secondary btn-sm rounded-small text-xxs shadow text-dark me-2"
              @click="close_delete_modal"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-danger btn-sm rounded-small text-xxs shadow text-dark"
              @click="delete_rule"
              :disabled="is_deleting"
            >
              {{ is_deleting ? 'Deleting...' : 'Delete Rule' }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </teleport>


  
  <!-- Question Assignment Modal Component -->
  <ComplianceQuestionAssignment
    :selected_rule="selected_rule"
    :entity_type_id="entity_type_id"
    :is_visible="show_assign_modal"
    @close="close_assign_questions_modal"
    @updated="on_assignment_updated"
  />
</div>